import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default function TabContent({ className, selected, children }) {
	return (
		<div className={classnames(className, 'tab-carousel-content', { selected })}>
			{children}
		</div>
	);
}

TabContent.propTypes = {
	className: PropTypes.string,
	selected: PropTypes.bool,
	children: PropTypes.node.isRequired
};

TabContent.defaultProps = {
	selected: false
};
